// extracted by mini-css-extract-plugin
module.exports = {"label":"UploadButton_label__zf9_l","input":"UploadButton_input__KyDNW"};